module.exports = __webpack_public_path__ + "static/media/back-arrow.f8bafd62.svg";